import type { ProductSubscription } from '@/models/product-subscription'
import { atom, map } from 'nanostores'

export const $subscription = atom<ProductSubscription | null>(null)
export const $promises = map<Record<string, Promise<any> | undefined>>()

export const loggables = {
  'product-subscription/$subscription': $subscription,
  // 'product-subscription/$promises': $promises,
}
